<div class="bg-m0 flex flex-col p-9">
  <div class="text-s2 mt-5 select-none text-left text-2xl font-semibold"
    >Sign In with ChatGPT</div
  >

  <div class="text-s2 mt-9 select-none text-left text-base"
    >Open this URL on any device</div
  >

  <div class="relative mt-3 h-[56px] w-full">
    <div *ngIf="verificationUrl" class="flex h-full items-center">
      <a
        class="text-m600 break-all text-base underline"
        [href]="verificationUrl"
        target="_blank"
        rel="noopener noreferrer"
        >{{ verificationUrl }}</a
      >
    </div>
    <ngx-spinner
      [ngClass]="{ invisible: !!verificationUrl }"
      class="invisible"
      [name]="spinnerName"
      color="#0084d1"
      bdColor="#00000000"
      size="default"
      type="ball-clip-rotate"
      [fullScreen]="false"
      [disableAnimation]="true"
      [zIndex]="10"
    >
    </ngx-spinner>
  </div>

  <div class="text-s2 mt-5 select-none text-left text-base"
    >Enter this code</div
  >

  <div class="relative mt-3 h-[56px] w-full">
    <div *ngIf="userCode" class="flex h-full items-center justify-between">
      <span class="text-s2 font-mono text-2xl tracking-widest">{{
        userCode
      }}</span>
      <button
        class="border-s400 text-s500 ml-3 w-[140px] flex-shrink-0 select-none rounded border py-3 text-base font-medium focus:outline-none"
        type="button"
        (click)="copyCode()"
      >
        {{ copiedCode ? 'Copied!' : 'Copy Code' }}
      </button>
    </div>
  </div>

  <div class="relative mt-5 h-6">
    <div
      *ngIf="userCode && !errorMessage"
      class="text-s500 select-none text-left text-base"
      >Waiting for authorization…</div
    >
    <div *ngIf="errorMessage" class="text-r1 select-none text-left text-base">{{
      errorMessage
    }}</div>
  </div>

  <div class="mt-8 flex flex-row items-center">
    <button
      *ngIf="errorMessage"
      class="bg-m600 text-m0 w-28 select-none rounded py-3 font-medium focus:outline-none"
      type="button"
      (click)="retry()"
      >Retry</button
    >
    <button
      class="border-m600 text-m600 select-none rounded border py-3 font-medium focus:outline-none"
      [ngClass]="{ 'ml-3 w-28': errorMessage, 'w-28': !errorMessage }"
      type="button"
      (click)="close()"
      >Cancel</button
    >
  </div>
</div>
